import * as Handlebars from 'handlebars/runtime'
module.exports = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"dialog-header\">\n	<h1>"
    + container.escapeExpression((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"admin.sharedDashboards.shareDashboard",(depth0 != null ? lookupProperty(depth0,"singular") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":2,"column":5},"end":{"line":2,"column":62}}}))
    + "</h1>\n</div>\n\n<!-- Links Template appended here -->\n";
},"useData":true})